import React from "react";
import { Lock, CheckCircle2, Building2, FileText } from "lucide-react";

const badges = [
  { icon: Lock, title: "Secure Handling", desc: "Confidential data practices" },
  { icon: Building2, title: "Partner Network", desc: "Multi-lender access & options" },
  { icon: CheckCircle2, title: "Best-Fit Guidance", desc: "Eligibility & offer matching" },
  { icon: FileText, title: "Transparent Process", desc: "Clear steps & documentation" },
];

export default function TrustBadges() {
  return (
    <section className="py-10 bg-[#F8F4EF] border-y border-gray-200">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {badges.map((b, idx) => {
            const Icon = b.icon;
            return (
              <div key={idx} className="bg-white rounded-2xl border border-gray-200 p-5">
                <Icon className="text-[#354F37]" size={22} />
                <div className="mt-3 font-bold text-[#222]">{b.title}</div>
                <div className="mt-1 text-sm text-[#555]">{b.desc}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
